/**
 * Tâche 1287 (Eric 2026-06-30) — Registre des écrans et des ACTIONS nommées
 * atteignables depuis la barre de recherche d'actions (Ctrl+K).
 *
 * Une action pointe vers un écran ET vers le bouton qui l'exécute
 * (`focus` = le `data-testid` du bouton). La palette navigue puis surligne ce
 * bouton — l'utilisateur voit où cliquer, on ne clique jamais à sa place sur
 * une opération qui coûte des crédits ou qui efface des données.
 *
 * Tâche 1395 (audit i18n) — Les deux langues vivent sur LA MÊME LIGNE
 * (`label` / `label_en`), motif 1324b : deux tables jumelles divergent au
 * premier ajout. Les mots-clés des DEUX langues restent cherchables quelle
 * que soit la langue de l'écran — une personne bilingue tape le mot qui lui
 * vient, et lui refuser « queue » parce que l'écran est en français serait
 * du zèle inutile.
 */

export const SCREENS = [
  { id: "screen-dashboard", label: "Tableau de bord", label_en: "Dashboard", path: "/dashboard", keywords: "accueil home stats", keywords_en: "home overview stats" },
  { id: "screen-explorer", label: "Explorateur de fichiers", label_en: "File explorer", path: "/dashboard/explorer", keywords: "fichiers vidéos documents bibliothèque", keywords_en: "files videos documents library" },
  { id: "screen-knowledge", label: "Connaissances", label_en: "Knowledge", path: "/dashboard/knowledge", keywords: "q&r concepts procédures scripts objections", keywords_en: "q&a concepts procedures scripts objections" },
  { id: "screen-dictionary", label: "Dictionnaire", label_en: "Dictionary", path: "/dashboard/dictionary", keywords: "jargon termes vocabulaire définitions", keywords_en: "jargon terms vocabulary definitions" },
  { id: "screen-tags", label: "Étiquettes", label_en: "Tags", path: "/dashboard/tags", keywords: "tags mots-clés vocabulaire contrôlé", keywords_en: "tags keywords controlled vocabulary" },
  { id: "screen-transcriptions", label: "Transcriptions", label_en: "Transcripts", path: "/dashboard/transcriptions", keywords: "whisper fireflies fusion", keywords_en: "whisper fireflies merge" },
  { id: "screen-gaps", label: "Écarts de couverture", label_en: "Coverage gaps", path: "/dashboard/gaps", keywords: "écarts passages manqués couverture fireflies", keywords_en: "gaps missed passages coverage fireflies" },
  { id: "screen-amf", label: "Conformité AMF", label_en: "AMF compliance", path: "/dashboard/amf-compliance", keywords: "amf heures unités formation continue", keywords_en: "amf hours units continuing education" },
  { id: "screen-scoring", label: "Scoring de conformité", label_en: "Compliance scoring", path: "/dashboard/admin/compliance-scoring", keywords: "amf scoring note verdict risques", keywords_en: "amf scoring grade verdict risks" },
  { id: "screen-quiz", label: "Quiz", label_en: "Quiz", path: "/dashboard/quiz", keywords: "questionnaire évaluation", keywords_en: "questionnaire assessment" },
  { id: "screen-chat", label: "Assistant Knoria", label_en: "Knoria assistant", path: "/dashboard/chat", keywords: "chat ia question rag", keywords_en: "chat ai question rag" },
  { id: "screen-pathways-onboarding", label: "Parcours d'accueil", label_en: "Onboarding pathway", path: "/dashboard/onboarding", keywords: "parcours onboarding intégration", keywords_en: "pathway onboarding ramp-up" },
  { id: "screen-pathways-learning", label: "Parcours d'apprentissage", label_en: "Learning pathway", path: "/dashboard/learning-path", keywords: "parcours formation apprentissage", keywords_en: "pathway training learning" },
  { id: "screen-weekly", label: "Formations hebdomadaires", label_en: "Weekly trainings", path: "/dashboard/weekly-trainings", keywords: "parcours semaine hebdo", keywords_en: "pathway week weekly" },
  { id: "screen-validation", label: "Validation rapide", label_en: "Quick validation", path: "/dashboard/validation-rapide", keywords: "réviser approuver file", keywords_en: "review approve queue" },
  { id: "screen-bilan", label: "Bilan de la base de connaissances", label_en: "Knowledge base health", path: "/dashboard/bilan-kb", keywords: "bilan maturité score kb", keywords_en: "health maturity score kb" },
  { id: "screen-speakers", label: "Locuteurs", label_en: "Speakers", path: "/dashboard/speakers", keywords: "intervenants diarisation voix", keywords_en: "speakers diarization voice" },
  { id: "screen-jargon-admin", label: "Administration du dictionnaire", label_en: "Dictionary administration", path: "/dashboard/admin/jargon", keywords: "jargon doublons fusion candidats", keywords_en: "jargon duplicates merge candidates" },
  { id: "screen-preferences", label: "Préférences", label_en: "Preferences", path: "/dashboard/preferences", keywords: "réglages courriels langue notifications", keywords_en: "settings emails language notifications" },
  { id: "screen-billing", label: "Facturation", label_en: "Billing", path: "/dashboard/billing", keywords: "abonnement paiement stripe", keywords_en: "subscription payment stripe" },
  { id: "screen-ai-package", label: "Forfait IA", label_en: "AI package", path: "/dashboard/settings/ai-package", keywords: "byok clés api budget", keywords_en: "byok api keys budget" },
  { id: "screen-favorites", label: "Mes favoris", label_en: "My favourites", path: "/dashboard/favorites", keywords: "coeur favoris marqués", keywords_en: "heart favourites bookmarked" },
  { id: "screen-agora", label: "Agora", label_en: "Agora", path: "/dashboard/agora", keywords: "discussions communauté", keywords_en: "discussions community" },
  { id: "screen-privacy", label: "Confidentialité", label_en: "Privacy", path: "/dashboard/privacy", keywords: "loi 25 vie privée registre", keywords_en: "law 25 privacy register" },
];

export const ACTIONS = [
  {
    id: "action-copie-fidele",
    label: "Copie fidèle sur sélection",
    label_en: "Faithful copy on selection",
    path: "/dashboard/explorer",
    focus: "btn-bulk-copy-fusion",
    keywords: "copie fidele fusion fireflies whisper lot batch transcription",
    keywords_en: "faithful copy merge fireflies whisper batch transcript",
    hint: "Explorateur de fichiers",
    hint_en: "File explorer",
  },
  {
    id: "action-injecter-ecarts",
    label: "Injecter les écarts Fireflies en lot",
    label_en: "Inject Fireflies gaps in batch",
    path: "/dashboard/explorer",
    focus: "explorer-bulk-gap-inject",
    keywords: "ecarts injection fireflies lot manques passages",
    keywords_en: "gaps injection fireflies batch missing passages",
    hint: "Explorateur de fichiers",
    hint_en: "File explorer",
  },
  {
    id: "action-detecter-ecarts",
    label: "Détecter les écarts (recalcul)",
    label_en: "Detect gaps (recompute)",
    path: "/dashboard/gaps",
    focus: "gaps-dashboard-compute",
    keywords: "detecter ecarts recalculer couverture classement manques",
    keywords_en: "detect gaps recompute coverage ranking missing",
    hint: "Écarts de couverture",
    hint_en: "Coverage gaps",
  },
  {
    id: "action-journal-ecarts",
    label: "Journal des injections d'écarts",
    label_en: "Gap injections journal",
    path: "/dashboard/gaps",
    focus: "gap-injections-journal",
    keywords: "journal injections annuler rollback auteur lot ecarts",
    keywords_en: "journal injections undo rollback author batch gaps",
    hint: "Écarts de couverture",
    hint_en: "Coverage gaps",
  },
  {
    id: "action-courriel-ecarts",
    label: "Courriel hebdomadaire des écarts",
    label_en: "Weekly gaps email",
    path: "/dashboard/gaps",
    focus: "gaps-weekly-email-toggle",
    keywords: "courriel email hebdomadaire ecarts recapitulatif abonnement",
    keywords_en: "email weekly gaps digest subscription",
    hint: "Écarts de couverture",
    hint_en: "Coverage gaps",
  },
  {
    id: "action-scoring-amf",
    label: "Scoring AMF de toutes les vidéos",
    label_en: "AMF scoring of every video",
    path: "/dashboard/admin/compliance-scoring",
    focus: "compliance-score-all-btn",
    keywords: "scoring amf conformite noter lot verdict",
    keywords_en: "scoring amf compliance grade batch verdict",
    hint: "Scoring de conformité",
    hint_en: "Compliance scoring",
  },
  {
    id: "action-importer-tags",
    label: "Importer des étiquettes",
    label_en: "Import tags",
    path: "/dashboard/tags",
    focus: "tags-page-import-btn",
    keywords: "importer tags etiquettes csv xlsx vocabulaire",
    keywords_en: "import tags csv xlsx vocabulary",
    hint: "Étiquettes",
    hint_en: "Tags",
  },
  {
    id: "action-annuler-import-tags",
    label: "Annuler le dernier import d'étiquettes",
    label_en: "Undo the last tag import",
    path: "/dashboard/tags",
    focus: "tags-page-import-rollback-btn",
    keywords: "annuler rollback import tags etiquettes",
    keywords_en: "undo rollback import tags",
    hint: "Étiquettes",
    hint_en: "Tags",
  },
  {
    id: "action-importer-connaissances",
    label: "Importer des connaissances",
    label_en: "Import knowledge",
    path: "/dashboard/knowledge/import",
    keywords: "importer q&r faq docx connaissances fichier",
    keywords_en: "import q&a faq docx knowledge file",
    hint: "Connaissances",
    hint_en: "Knowledge",
  },
  {
    id: "action-televerser-video",
    label: "Téléverser une vidéo",
    label_en: "Upload a video",
    path: "/dashboard/upload",
    keywords: "televerser upload video ajouter",
    keywords_en: "upload video add",
  },
  {
    id: "action-televerser-texte",
    label: "Téléverser un document texte",
    label_en: "Upload a text document",
    path: "/dashboard/upload-text",
    keywords: "televerser upload document texte docx pdf",
    keywords_en: "upload text document docx pdf",
  },
  {
    id: "action-doublons-dictionnaire",
    label: "Détecter les doublons du dictionnaire",
    label_en: "Detect dictionary duplicates",
    path: "/dashboard/admin/jargon",
    keywords: "doublons dictionnaire jargon fusionner detecter",
    keywords_en: "duplicates dictionary jargon merge detect",
    hint: "Administration du dictionnaire",
    hint_en: "Dictionary administration",
  },
  {
    id: "action-termes-a-valider",
    label: "Termes du dictionnaire à valider",
    label_en: "Dictionary terms awaiting validation",
    path: "/dashboard/admin/jargon",
    keywords: "valider termes pending dictionnaire file",
    keywords_en: "validate terms pending dictionary queue",
    hint: "Administration du dictionnaire",
    hint_en: "Dictionary administration",
  },
  {
    id: "action-sauvegardes",
    label: "Sauvegardes",
    label_en: "Backups",
    path: "/dashboard/admin/backups",
    keywords: "sauvegarde backup restauration",
    keywords_en: "backup restore",
  },
  {
    id: "action-matrice-acces",
    label: "Matrice des accès",
    label_en: "Access matrix",
    path: "/dashboard/admin/access-matrix",
    keywords: "acces roles permissions matrice",
    keywords_en: "access roles permissions matrix",
  },
  {
    id: "action-file-attente-videos",
    label: "File d'attente des vidéos",
    label_en: "Video queue",
    path: "/dashboard/video-queue",
    keywords: "file attente pipeline traitement videos",
    keywords_en: "queue pipeline processing videos",
  },
];

/** Enlève les accents et la casse pour une recherche tolérante. */
export const foldText = (s) =>
  (s || "")
    .toString()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();

/** Tâche 1395 — Résout une entrée du registre dans la langue de l'écran. */
export function localizeCommand(item, lang) {
  if (lang !== "en") return item;
  return {
    ...item,
    label: item.label_en || item.label,
    hint: item.hint_en || item.hint,
  };
}

export function searchCommands(query, lang = "fr") {
  const q = foldText(query).trim();
  const score = (item) => {
    const label = foldText(lang === "en" ? item.label_en || item.label : item.label);
    const hay = [
      label,
      foldText(item.label),
      foldText(item.label_en),
      foldText(item.keywords),
      foldText(item.keywords_en),
      foldText(item.hint),
      foldText(item.hint_en),
    ].join(" ");
    if (!q) return 1;
    if (label.startsWith(q)) return 100;
    if (label.includes(q)) return 60;
    const words = q.split(/\s+/).filter(Boolean);
    if (words.every((w) => hay.includes(w))) return 30;
    return 0;
  };
  const rank = (list) =>
    list
      .map((item) => ({ item: localizeCommand(item, lang), s: score(item) }))
      .filter((r) => r.s > 0)
      .sort((a, b) => b.s - a.s || a.item.label.localeCompare(b.item.label))
      .map((r) => r.item);
  return { actions: rank(ACTIONS), screens: rank(SCREENS) };
}
